export default {
    classification_list:[
        {name: '验真', value: 1},
        {name: '自主注册', value: 2},
        {name: 'DTP注册', value: 3},
        {name: '医生端注册', value: 4},
        {name: '试点随访', value: 5},
        {name: '异地就诊', value: 6},
    ],
}